// extracted by mini-css-extract-plugin
module.exports = {"note":"style-module_note__38jk38dOQLUBACJ_Lsw4G2","checkboxNote":"style-module_checkboxNote__5lcWzlB5bEFUxabkkxFCl","header":"style-module_header__Jt-VngYMQ5ZnAb5Jy9yEs"};